import React from 'react';
import { BoxV2 as Box, Flex, Button, RoleGuard } from 'portal-commons';
import BrandAssetsList from './BrandAssetsList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImage } from '@fortawesome/pro-regular-svg-icons';
import { AppealCategoryData, VettingAppeal } from '../../types';

type UploaderType = 'logo' | 'banner';
interface Props {
  onOpenUploader: (type: UploaderType) => void;
  onOpenEmulator: () => void;
  actionGuard?: (func: (...args: any[]) => any) => any;
  appealCategories?: AppealCategoryData[];
  enabledCategoryIds?: string[];
  onAppealCreated: (appeal: VettingAppeal) => void;
}

const BrandAssets: React.FC<Props> = ({
  onOpenUploader,
  onOpenEmulator,
  actionGuard = (func: (...args: any[]) => any) =>
    (...args: any[]) =>
      func(...args),
  appealCategories = [],
  enabledCategoryIds = [],
  onAppealCreated,
}) => {
  return (
    <Box
      sx={{
        maxWidth: '100%',
        p: 'xxl',
        pt: 'xl',
        mb: 30,
        border: '1px solid #C0CCD4',
        flexBasis: '100%',
        flexGrow: 0,
      }}
      data-testid="brandAssetsContainer"
    >
      <Flex sx={{ justifyContent: 'space-between', mb: 'xxs' }}>
        <Flex
          as="h3"
          sx={{
            alignItems: 'center',
            fontSize: 'H500',
            color: 't.black70',
            fontWeight: 600,
            lineHeight: 'xxl',
            '& svg': {
              fontSize: 'H600',
              mr: 'xs',
            },
          }}
        >
          <FontAwesomeIcon icon={faFileImage} />
          Brand Assets
        </Flex>
        <Flex sx={{ alignItems: 'center', gap: 's' }}>
          <RoleGuard feature="brandDetail.addLogo">
            <Button
              shape="square"
              size="small"
              onClick={actionGuard(() => onOpenUploader('logo'))}
              data-testid="addLogoButton"
            >
              Add Logo
            </Button>
          </RoleGuard>
          <RoleGuard feature="brandDetail.addBanner">
            <Button
              shape="square"
              size="small"
              onClick={actionGuard(() => onOpenUploader('banner'))}
              data-testid="addBannerButton"
            >
              Add Banner
            </Button>
          </RoleGuard>
        </Flex>
      </Flex>
      <Box
        sx={{
          mb: 'xs',
          fontSize: 'H300',
          color: 'black',
          fontWeight: 400,
        }}
      >
        Add and verify your assets to use them on RCS.
      </Box>
      <BrandAssetsList
        onOpenEmulator={onOpenEmulator}
        appealCategories={appealCategories}
        enabledCategoryIds={enabledCategoryIds}
        onAppealCreated={onAppealCreated}
        actionGuard={actionGuard}
      />
    </Box>
  );
};

export default BrandAssets;
